import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  DropdownTriggerDirective,
  MenuItem,
  SvgIconComponent,
} from '@ui-lib/components';
import { Observable } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { AuthService } from '../../../core/services/auth/auth.service';
import { UserInformationService } from '../../../core/services/user/user-information.service';
import { LanguageService } from '../../../core/services/language/language.service';
import { LanguageCode } from '../../../core/services/language/language.const';
import { environment } from '../../../../environments/environment';
import {
  HEADER_MENU_ITEMS_NATIVE,
  HEADER_MENU_ITEMS_WEB,
} from '../header/header-menu.const';
import { PROFILE_MENU_ITEMS } from '../../../profile/profile.constants';

const NAV_MENU_ITEMS = Capacitor.isNativePlatform()
  ? HEADER_MENU_ITEMS_NATIVE
  : HEADER_MENU_ITEMS_WEB;

// Источник истины — сам enum: при добавлении языка не нужно править этот список.
const LANGUAGE_ORDER: readonly LanguageCode[] = Object.values(LanguageCode);

@Component({
  selector: 'rrp-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrl: './mobile-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [
    AsyncPipe,
    NgTemplateOutlet,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    SvgIconComponent,
    DropdownTriggerDirective,
  ],
})
export class MobileMenuComponent {
  private readonly authService = inject(AuthService);
  private readonly languageService = inject(LanguageService);
  private readonly userInformationService = inject(UserInformationService);

  public readonly navMenuItems: MenuItem[] = NAV_MENU_ITEMS;
  public readonly profileMenuItems: MenuItem[] = PROFILE_MENU_ITEMS;

  public readonly userInfo$ = this.userInformationService.userInfo$;

  public readonly currentLanguage$: Observable<string> =
    this.languageService.getCurentLanguageObservable();

  public cycleLanguage(): void {
    const currentLanguage = this.languageService.getCurentLanguage();
    const currentIndex = LANGUAGE_ORDER.findIndex(
      (lang) => lang === currentLanguage,
    );

    const nextIndex =
      currentIndex === -1 ? 0 : (currentIndex + 1) % LANGUAGE_ORDER.length;

    this.languageService.setCurrentLanguage(LANGUAGE_ORDER[nextIndex]);
  }

  public openAdminPanel(): void {
    const currentLanguage = this.languageService.getCurentLanguage();

    window.location.href = `${environment.adminPanelUrl}?lang=${currentLanguage}`;
  }

  public logout(): void {
    void this.authService.logout();
  }
}
